export function getApiBaseUrl(): string {
  const envUrl = (import.meta as any).env?.VITE_API_BASE_URL as string | undefined
  if (envUrl && typeof envUrl === 'string') {
    return envUrl.replace(/\/+$/, '')
  }

  // Use runtime location when no explicit deployment URL was provided.
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname || 'localhost'
    const protocol = window.location.protocol || 'http:'
    
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000'
    }
    
    // For any other hostname (prod/staging/etc): ALWAYS use current hostname:8000
    return `${protocol}//${hostname}:8000`
  }

  // Build-time fallback (SSR/prerender)
  return 'http://localhost:8000'
}

export function getWsBaseUrl(apiBaseUrl?: string): string {
  const base = (apiBaseUrl || getApiBaseUrl()).replace(/\/+$/, '')
  return base.replace(/^http:\/\//, 'ws://').replace(/^https:\/\//, 'wss://')
}


